import React, { useState } from "react";
import { getActionsBasedOnPosition } from "./actionUtils";

const ChrCollapsible = (props) => {
  const {
    title,
    collapsed,
    collapsible,
    contentClass,
    hover = true,
    headerClass = "",
    titleWrapperClass = "",
    indicatorOnRight = false,
    wrapperClass = "m-b-md",
  } = props;
  const [isCollapsed, setIsCollapsed] = useState(collapsible && collapsed);
  const iconClass = isCollapsed ? "fa-angle-right" : "fa-angle-down";
  const hoverClass = hover ? "cui-hover-effect" : "";
  let _leftActions, rightActions;
  if (props.headerActions) {
    ({ _leftActions, rightActions } = getActionsBasedOnPosition(props.headerActions));
  }

  const onClickHandler = () => {
    if (!collapsible) return;
    setIsCollapsed(prevIsCollapsed => !prevIsCollapsed);
  };

  return (
    <div className={wrapperClass}>
      <div className= { `d-flex align-items-center cui-collapsible-header ${hoverClass} font-normal ${headerClass}` }>
        <div className={`d-flex align-items-center flex-1 cui-management-report-temp-section-header ${titleWrapperClass}`} onClick={ onClickHandler }>
          {
            title &&
            <div>{ title }</div>
          }
          { collapsible && <i className={ `${indicatorOnRight ? "ml-auto pl-2" : "ml-2"} fa-regular ${iconClass}` } /> }
        </div>
        {
          rightActions &&
          <div className="ml-auto">
            { rightActions }
          </div>
        }
      </div>
      <div className={ "m-b-lg collapse " + (isCollapsed ? "" : "show ") + contentClass } >
        { props.children }
      </div>
    </div>
  );
};

export default ChrCollapsible;